
import { defineComponent, reactive } from '@vue/runtime-core';
import { ClientConstants } from './../client.constants';
import ContentComponent from './../components/Content.vue';
import store from './../store/store';

export default defineComponent({
  name: 'EducationView',
  components: { ContentComponent },
  computed: {
    contentAvailable(): boolean {
      return this.store.contentLoaded;
    },
    contentError(): boolean {
      return this.store.contentError;
    }
  },
  data: () => {
    return {
      clientConstants: ClientConstants,
      store: reactive(store)
    };
  }
});
